<template>
    <div>
        <el-row class="p-4 text-center" v-if="user && user.is_fullaccess">
            <a href="/dashboard">
                <el-button type="info" size="large" round>Sales</el-button>
            </a>
            <a class="ml-2" href="/dashboard?type=operation">
                <el-button type="info" size="large" round>Operation</el-button>
            </a>
            <a class="ml-2" href="/dashboard?type=account">
                <el-button type="info" size="large" round>Account</el-button>
            </a>
            <a class="ml-2" href="/dashboard?type=qc">
                <el-button type="info" size="large" round>QC</el-button>
            </a>
        </el-row>

        <el-row class="pt-2" justify="end">
            <el-col :span="6">
                <el-date-picker
                    @change="getdata"
                    v-model="form.date"
                    type="daterange"
                    range-separator="To"
                    start-placeholder="Start date"
                    end-placeholder="End date"
                    format="DD MMM YYYY"
                    value-format="YYYY-MM-DD"
                />
            </el-col>
        </el-row>

        <el-row class="ml-4 mr-4 mt-2" v-if="reports != null" :gutter="16">
            <el-col :span="4">
                <div class="statistic-card">
                    <el-statistic :value="reports.dayleads">
                        <template #title>
                            <div style="display: inline-flex; align-items: center">
                                Day Leads
                            </div>
                        </template>
                    </el-statistic>
                </div>
            </el-col>

            <el-col :span="4">
                <div class="statistic-card">
                    <el-statistic :value="reports.cnp">
                        <template #title>
                            <div style="display: inline-flex; align-items: center">
                                Call Not Picked
                                <el-tooltip
                                    effect="dark"
                                    :content="'Day - ' + reports.cnpd + '  Older - ' + reports.cnpp"
                                    placement="top"
                                >
                                    <el-icon style="margin-left: 4px" :size="12">
                                        <Warning />
                                    </el-icon>
                                </el-tooltip>
                            </div>
                        </template>
                    </el-statistic>
                </div>
            </el-col>

            <el-col :span="4">
                <div class="statistic-card">
                    <el-statistic :value="reports.called">
                        <template #title>
                            <div style="display: inline-flex; align-items: center">
                                Called Leads
                                <el-tooltip
                                    effect="dark"
                                    :content="'Day - ' + reports.calledd + '  Older - ' + reports.calledp"
                                    placement="top"
                                >
                                    <el-icon style="margin-left: 4px" :size="12">
                                        <Warning />
                                    </el-icon>
                                </el-tooltip>
                            </div>
                        </template>
                    </el-statistic>
                </div>
            </el-col>

            <el-col :span="4">
                <div class="statistic-card">
                    <el-statistic :value="reports.closed">
                        <template #title>
                            <div style="display: inline-flex; align-items: center">
                                Closed Leads
                                <el-tooltip
                                    effect="dark"
                                    :content="'Day - ' + reports.closedd + '   Older - ' + reports.closedp"
                                    placement="top"
                                >
                                    <el-icon style="margin-left: 4px" :size="12">
                                        <Warning />
                                    </el-icon>
                                </el-tooltip>
                            </div>
                        </template>
                    </el-statistic>
                </div>
            </el-col>

            <el-col :span="4">
                <div class="statistic-card">
                    <el-statistic :value="reports.verified">
                        <template #title>
                            <div style="display: inline-flex; align-items: center">
                                QC Verified
                                <el-tooltip
                                    effect="dark"
                                    :content="'Day - ' + reports.verifiedd + '   Older - ' + reports.verifiedp"
                                    placement="top"
                                >
                                    <el-icon style="margin-left: 4px" :size="12">
                                        <Warning />
                                    </el-icon>
                                </el-tooltip>
                            </div>
                        </template>
                    </el-statistic>
                </div>
            </el-col>

            <el-col :span="4">
                <div class="statistic-card">
                    <el-statistic :value="reports.autoverified">
                        <template #title>
                            <div style="display: inline-flex; align-items: center">
                                Auto Verified
                                <el-tooltip
                                    effect="dark"
                                    :content="'Day - ' + reports.autoverifiedd + '   Older - ' + reports.autoverifiedp"
                                    placement="top"
                                >
                                    <el-icon style="margin-left: 4px" :size="12">
                                        <Warning />
                                    </el-icon>
                                </el-tooltip>
                            </div>
                        </template>
                    </el-statistic>
                </div>
            </el-col>
        </el-row>

        <el-row class="m-4" v-if="reports != null">
            <el-table
                v-if="reports.list.length > 0"
                :data="reports.list"
                style="width: 100%; margin-bottom: 20px"
                row-key="name"
                border
                :tree-props="{ children: 'list' }"
            >
                <el-table-column prop="name" label="Name" width="200" />
                <el-table-column prop="called" label="Called Leads" />
                <el-table-column prop="cnp" label="Call Not Picked" />
                <el-table-column prop="closed" label="Closed" />
                <el-table-column prop="verified" label="Verified" />
            </el-table>
        </el-row>

        <el-row class="m-4" v-if="reports != null">
            <el-col :span="24">
                <vue-apex-charts
                    type="line"
                    height="350"
                    :options="leadsstatusCO"
                    :series="reports.graph.leads.report"
                ></vue-apex-charts>
            </el-col>
        </el-row>

    </div>
</template>

<script>
import {
    ElRow, ElButton, ElDatePicker, ElCol, ElTableColumn, ElTable,
    ElStatistic, ElTooltip, ElIcon, ElSkeleton
} from 'element-plus';
import { ElLoading } from 'element-plus';
import 'element-plus/dist/index.css';
import moment from "moment";
import VueApexCharts from "vue3-apexcharts";
import { ArrowRight, CaretBottom, CaretTop, Warning } from '@element-plus/icons-vue';

let loading = null;

export default {
    name: "SalesDashboard",
    components: {
        VueApexCharts, ElRow, ElButton, ElDatePicker, ElCol, ElTableColumn,
        ElTable, ElStatistic, ElTooltip, ElIcon, Warning, ElSkeleton
    },
    data() {
        return {
            form: {
                date: [
                    moment().startOf('month').format('YYYY-MM-DD'),
                    moment().format('YYYY-MM-DD')
                ],
            },
            user: null,
            reports: null,
            leadsstatusCO: {
                legend: {
                    onItemClick: {
                        toggleDataSeries: true
                    },
                },
                chart: {
                    height: 350,
                    type: 'line',
                    zoom: {
                        enabled: false
                    }
                },
                dataLabels: {
                    enabled: true
                },
                stroke: {
                    curve: 'straight',
                    width: 2
                },
                title: {
                    text: 'Leads Report',
                    align: 'left'
                },
                grid: {
                    row: {
                        colors: ['#f3f3f3', 'transparent'],
                        opacity: 0.5
                    },
                },
                xaxis: {
                    categories: [],
                },
                yaxis: {
                    title: {
                        text: 'Leads'
                    },
                    min: 0
                },
                markers: {
                    size: 1
                },
            },
        };
    },
    mounted() {
        this.getdata();
    },
    methods: {
        getdata() {
            loading = ElLoading.service({
                lock: true,
                text: 'Loading',
                background: 'rgba(0, 0, 0, 0.7)',
            });
            let currentObj = this;
            currentObj.reports = null;
            axios.post('/dashboard/agetqcdata', this.form).then(function (response) {
                currentObj.reports = response.data.report;
                currentObj.user = response.data.user;
                currentObj.leadsstatusCO.xaxis = response.data.report.graph.leads.xaxis;
                loading.close();
            }).catch(function (error) {
                loading.close();
            });
        }
    }
};
</script>

<style scoped>
:global(h2#card-usage ~ .example .example-showcase) {
    background-color: var(--el-fill-color) !important;
}

.el-statistic {
    --el-statistic-content-font-size: 28px;
}

.statistic-card {
    height: 100%;
    padding: 20px;
    border-radius: 4px;
    background-color: var(--el-bg-color-overlay);
}

.statistic-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    font-size: 12px;
    color: var(--el-text-color-regular);
    margin-top: 16px;
}

.statistic-footer .footer-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.statistic-footer .footer-item span:last-child {
    display: inline-flex;
    align-items: center;
    margin-left: 4px;
}

.green {
    color: var(--el-color-success);
}

.red {
    color: var(--el-color-error);
}
</style>